import { FC } from 'react'
import styled from '@emotion/styled'
import { ReactComponent as OnlineIcon } from './img/online.svg'
import { ReactComponent as OfflineIcon } from './img/offline.svg'

const Item = styled.div`
  svg {
    display: block;
  }
`
const OnlineStatus: FC<{
  online: boolean
}> = ({ online }) => {
  return <Item>{online ? <OnlineIcon /> : <OfflineIcon />}</Item>
}

export default OnlineStatus
